import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core'
import { Router } from '@angular/router'
import { CognitoUser } from '@aws-amplify/auth'
import { PopoverController, IonModal, ModalController } from '@ionic/angular'
import { Pia3AuthenticationService } from '../../authentication/authentication.service'
import { Pia3UserPerformanceChartTranscriptionDataminutesComponent } from '../pia3-user-performance-chart-transcription-dataminutes/pia3-user-performance-chart-transcription-dataminutes.component'

@Component({
    selector: 'pia3-current-user-fab-popover',
    templateUrl: './pia3-current-user-fab-popover.component.html',
    styleUrls: ['./pia3-current-user-fab-popover.component.scss'],
})
export class Pia3CurrentUserFabPopoverComponent implements OnInit {
    @ViewChild(IonModal) statsModal: IonModal
    @Input('senderEvent') senderEvent
    public currentUser: CognitoUser = null
    public userID: string = null
    public isStatsModalOpen: boolean = false
    public isTasksModalOpen: boolean = false

    constructor(public authService: Pia3AuthenticationService, public router: Router, public popoverController: PopoverController, public modalController: ModalController) {
        this.authService.currentLoggedInUser.subscribe((user) => {
            this.currentUser = user
            try {
                this.userID = user['attributes']['sub']
            } catch (error) {}
        })
    }

    ngOnInit() {}

    setStatsModalOpen(isOpen: boolean) {
        this.isStatsModalOpen = isOpen
    }

    setTasksModalOpen(isOpen: boolean) {
        this.isTasksModalOpen = isOpen
    }

    getUserEmailShort() {
        let userEmailShort: string = null
        try {
            userEmailShort = this.currentUser['attributes'].email.substring(0, this.currentUser['attributes'].email.indexOf('@'))
        } catch (error) {
            userEmailShort = 'Niet beschikbaar'
        }
        return userEmailShort
    }

    async openUserStatsModal() {
        const modal = await this.modalController.create({
            component: Pia3UserPerformanceChartTranscriptionDataminutesComponent,
            componentProps: {
                userID: this.userID,
            },
        })
        modal.present()
    }

    logout() {
        this.authService.signOutUser().then(() => {
            this.popoverController.dismiss()
        })
    }
}
